import React, {useRef} from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'

import {Button} from '@vio/atlas/Button'
import {Portal} from '@vio/atlas/helpers/Portal'
import {Icon} from '@vio/atlas/Icon'
import {NavBar} from '@vio/atlas/NavBar'
import useBodyScrollLock from '@vio/atlas/Overlay/useBodyScrollLock'

const Wrapper = styled.div`
  opacity: 0;
  display: none;
  height: 100vh;
  overflow: hidden;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 200;
  background-color: white;
  &.--is-open {
    opacity: 1;
    display: block;
  }
`

const ContentWrapper = styled.div`
  height: 100%;
`

const OverlayContent = ({children}) => {
  const ref = useRef<HTMLDivElement>(null)

  useBodyScrollLock({ref, isEnabled: true})

  return <ContentWrapper ref={ref}>{children}</ContentWrapper>
}

interface Props {
  isOpen: boolean
  header: React.ReactNode
  onClose: () => void
}
export const DestinationPickerPortal: React.FC<Props> = ({
  children,
  isOpen,
  onClose,
  header
}) => {
  return (
    <Portal>
      <Wrapper className={cx(isOpen && '--is-open')}>
        <NavBar
          centerContent={header}
          withDivider
          endContent={
            <Button
              variant="ghost"
              onClick={onClose}
              data-id="OverlayPageCloseButton"
              data-testid="DestinationPickerPortalCloseButton"
              iconStart={<Icon name="Close" />}
            />
          }
        />
        {isOpen && <OverlayContent>{children}</OverlayContent>}
      </Wrapper>
    </Portal>
  )
}
